export const GUIDE = '/guide';
export const GUIDE_ORGANIZATION = `${GUIDE}/organization/:organizationId`;
export const GUIDE_UNIT = `${GUIDE_ORGANIZATION}/unit/:unitId`;
export const GUIDE_STUDENT_PAGE = `${GUIDE_UNIT}/student/:studentId`;
export const GUIDE_TOPIC_PAGE = `${GUIDE_STUDENT_PAGE}/topic/:topicId`;
export const GUIDE_TOPIC = `${GUIDE}/topic/:topicId`;
